import cn from 'clsx';
import { observer } from 'mobx-react-lite';
import dynamic from 'next/dynamic';
import { useEffect } from 'react';

import { Tabs } from 'components/Tabs';
import { scrollTopAnchorId, searchScrollAnchorId } from 'constants/ui';
import { useStore } from 'hooks/useStore';
import { tabIds } from 'store/UIStore/UIStore';

import { BottomAdv } from './BottomAdv';
import { Favorites } from './Favorites';
import { Filters } from './Filters';
import { Controls } from './Filters/Controls';
import { SearchButton } from './Filters/SearchButton';
import { History } from './History';
import { Instructions } from './Instructions';
import { SavedFilters } from './SavedFilters';
import { SearchResults } from './SearchResults';
import { Trucks } from './Trucks';

import css from './Search.module.css';

// TODO: Если импортировать как обычно, то будет ошибка document is not defined в icons из ati-ui-react
const ErrorNotification = dynamic<{}>(() => import('components/ErrorNotification').then(mod => mod.ErrorNotification), {
  ssr: false,
});

const Search = () => {
  const {
    app: { i18n, searchResult, setLoading },
    ui: { tabs, isTabsPinned, toggleTabsPin, activeTab, setActiveTab },
    filter,
    tabsData,
    profile,
  } = useStore();

  useEffect(() => {
    tabsData.fetchTabsData();

    setLoading('allResources', true);

    window.addEventListener('load', () => {
      setLoading('allResources', false);
    });
  }, [tabsData, setLoading]);

  return (
    <div className={css.container}>
      <div className={css.topPart}>
        <ErrorNotification />

        <h1 className={cn('glz-h glz-is-size-1', css.h1)} id={scrollTopAnchorId}>
          {i18n.app.h1}
        </h1>

        <Tabs
          activeTab={activeTab}
          isPinned={isTabsPinned}
          tabsData={tabs}
          onChange={setActiveTab}
          onPin={toggleTabsPin}
        />

        {activeTab === tabIds.search && <Filters className={css.tab} />}

        {activeTab === tabIds.savedFilters && <SavedFilters className={css.tab} />}

        {activeTab === tabIds.history && <History className={css.tab} />}

        {activeTab === tabIds.byTrucks && <Trucks className={css.tab} />}

        {activeTab === tabIds.favorites && <Favorites />}

        {activeTab !== tabIds.favorites && (
          <>
            <div className={cn(css.row, css.bottomRow)} id={searchScrollAnchorId}>
              <Instructions />

              <div className={css.controlsContainer}>
                <Controls />
                <SearchButton />
              </div>
            </div>

            <div className={css.error}>{filter.error}</div>

            <div className={cn(css.banner, { [css.banner_hidden]: !searchResult || profile.data?.isPaidUser })}>
              <span ati-userdata-info="doc-preset=allpages_940_200" />
            </div>
          </>
        )}
      </div>

      <div className={css.bottomPart}>
        <SearchResults />

        <Favorites.Content />

        {searchResult && <BottomAdv />}
      </div>
    </div>
  );
};

const connected = observer(Search);

export { connected as Search };
